import AuthService from '../services/AuthService';
import jwtDecode from 'jwt-decode';
import Vue from 'vue';
import Notifications from 'src/components/NotificationPlugin';
import { cancelTopProgress } from 'src/progressbar';

Vue.use(Notifications);
// Used to show notifications;
let notifier = new Vue();

let errMessage = 'You are not authorized to view this page. Please log in again.';
let errNotification = {
  type: 'danger',
  message: errMessage
};

let loginRoute = {
  path: '/login'
};

function redirectToLogin(next) {
  cancelTopProgress();
  return next(loginRoute);
}

function redirectBack(next, to) {
  notifier.$notify(errNotification);
  return next(to.path);
}

/**
 * Middleware to check if user has the correct right to access a certain page.
 * Checks are performed based on route meta fields `meta: { requiresAuth: true }`.
 * @param {object} router Vue router instance
 */
export default function authMiddleware(router, store) {
  router.beforeEach((to, from, next) => {
    let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    if (!requiresAuth) {
      return next();
    }
    let record = to.matched.find(record => record.meta.permission);
    if(record) {
      let { permission } = record.meta;
      let canNavigate = notifier.$can(permission);
      if(!canNavigate) {
        return redirectBack(next, from);
      }
    }
    let token = AuthService.getToken();
    if (!token) {
      return redirectToLogin(next);
    }
    try {
      // Maybe use some information from token at some point
      jwtDecode(token);
      return next();
    } catch (err) {
      redirectToLogin(next);
    }
  });
}
